/**
 * エクスポートデータのスキーマバージョン履歴と型定義
 *
 * 新しいバージョンを追加する際は:
 * 1. ExportDataVx 型を追加
 * 2. migrations.ts にマイグレーション関数を追加
 * 3. CURRENT_VERSION を更新
 */

/**
 * Version 1: 初期スキーマ
 * - learningProgresses: 学習進捗データ
 * - learnerProfile: 受講者プロフィール
 */
export interface ExportDataV1 {
  version: 1;
  exportedAt: string;
  learningProgresses: Array<{
    id: string;
    courseId: string;
    lectureProgresses: Array<{
      lectureId: string;
      completed: boolean;
      completedAt: string | null;
    }>;
    examinationPassed: boolean;
    createdAt: string;
    updatedAt: string;
    passerToken?: string;
  }>;
  learnerProfile: {
    wantsAdvancedCourse: boolean;
    nickname: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}

// 将来のバージョン追加例:
// export interface ExportDataV2 {
//   version: 2;
//   // ...新しいフィールドや変更されたフィールド
// }

/**
 * 任意のバージョンのエクスポートデータ（マイグレーション入力用）
 */
export type AnyVersionExportData = ExportDataV1; // | ExportDataV2 | ...

/**
 * 最新バージョンのエクスポートデータ
 */
export type LatestExportData = ExportDataV1; // 新バージョン追加時に更新

/**
 * 現在のスキーマバージョン
 */
export const CURRENT_VERSION = 1;
